module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-02.7d3aec1c.png";